import {
    SET_USER,
    SET_PROFILE,
    SET_AUTH_DONE,
    SYNC_OFFLINE_USER,
    OFFLINE_AUTH_START,
    OFFLINE_AUTH_SUCCESS,
    OFFLINE_AUTH_FAILURE,
    OFFLINE_AUTH_RESET
} from '../actions/user';

const initialState = {
    user: null,
    profile: null,
    authDone: false,
    offlineUser: null,
    offlineAuthDone: false,
    offlineAuthError: null
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                user: action.payload
            };

        case SET_PROFILE:
            return {
                ...state,
                profile: action.payload
            };

        case SET_AUTH_DONE:
            return {
                ...state,
                authDone: action.payload
            };

        case SYNC_OFFLINE_USER:
            return {
                ...state,
                offlineUser: action.payload,
                offlineAuthDone: true,
                offlineAuthError: null
            };
        case OFFLINE_AUTH_START:
            return {
                ...state,
                offlineAuthError: null
            };
        case OFFLINE_AUTH_SUCCESS:
            return {
                ...state,
                offlineUser: action.payload,
                offlineAuthDone: true,
                offlineAuthError: null
            };
        case OFFLINE_AUTH_FAILURE:
            return {
                ...state,
                offlineUser: null,
                offlineAuthDone: false,
                offlineAuthError: action.payload
            };
        case OFFLINE_AUTH_RESET:
            return {
                ...state,
                offlineUser: null,
                offlineAuthDone: false,
                offlineAuthError: null
            };

        default:
            return state;
    }
}
